<!--
  Copyright 2024 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div [formGroup]="expressionControl" class="task-condition-form">
  <div i18n="@@app.labels.ifTheAnswerTo">If the answer to</div>

  <mat-form-field>
    <mat-label i18n="@@app.taskEditor.condition.selectQuestion"
      >Select question</mat-label
    >

    <mat-select formControlName="taskId">
      <mat-option *ngFor="let task of previousMultipleTasks" [value]="task.id">
        {{task.label}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="taskIdControl.touched && taskIdControl.invalid">
      <ng-container
        *ngIf="taskIdControl.hasError('required')"
        i18n="@@app.controls.errors.requiredQuestion"
        >A question must be selected as a condition</ng-container
      >
    </mat-error>
  </mat-form-field>

  <div i18n="@@app.labels.is">is</div>

  <mat-form-field>
    <mat-label i18n="@@app.taskEditor.condition.selectAnswer"
      >Select answer</mat-label
    >

    <mat-select formControlName="optionIds" multiple>
      <mat-option *ngFor="let option of previousMultipleTasks | getTaskOptions:taskIdControl.value" [value]="option.id">
        {{option.label}}
      </mat-option>
      <mat-option
        *ngIf="selectedTaskHasOtherOption"
        [value]="OTHER_OPTION_ID"
        i18n="@@app.taskEditor.condition.otherOption"
      >
        Other
      </mat-option>
    </mat-select>

    <mat-error *ngIf="optionIdsControl.touched && optionIdsControl.invalid">
      <ng-container
        *ngIf="optionIdsControl.hasError('required')"
        i18n="@@app.controls.errors.requiredAnswer"
        >At least one answer must be selected</ng-container
      >
    </mat-error>
  </mat-form-field>
</div>
